<div class="cd-root">
  <!-- Loading inicial -->
  <div *ngIf="loading && !data" class="cd-loading-overlay">
    <div class="cd-loading-card">
      <div class="cd-spinner"></div>
      <div class="cd-loading-text">Cargando perfil de cliente…</div>
    </div>
  </div>

  <!-- Error -->
  <div *ngIf="error" class="cd-card cd-card-error">
    <strong>Error:</strong> {{ error }}
    <button (click)="load()" class="cd-btn-ghost ct-btn-mini" style="margin-left:8px;">Reintentar</button>
  </div>

  <ng-container *ngIf="data">
    <!-- Header -->
    <header class="cd-header">
      <button class="cd-btn-back" (click)="goBack()">← Volver</button>
      <div class="cd-header-info">
        <h1>{{ data.person.full_name || data.person.code }}</h1>
        <div class="cd-subline">
          <span *ngIf="cedulaCliente" class="cd-soft">
            <i class="fas fa-id-card text-gray-500"></i>
            Cédula {{ cedulaCliente }}
          </span>
          <span *ngIf="data.person.email" class="cd-soft">· {{ data.person.email }}</span>
          <span *ngIf="data.person.phone" class="cd-soft">· {{ data.person.phone }}</span>
        </div>
      </div>
      <div class="cd-header-actions">
        <button class="cd-btn-ghost" (click)="recalcCliente()" [disabled]="actionLoading === 'recalc'">
          <span *ngIf="actionLoading === 'recalc'" class="cd-spinner-sm"></span>
          <i class="fas fa-redo"></i>
          Recalcular mora
        </button>
      </div>
    </header>
    <div *ngIf="actionMessage" class="cd-action-msg">{{ actionMessage }}</div>

    <!-- KPI cards -->
    <section class="cd-kpis">
      <div class="cd-kpi">
        <div class="cd-kpi-label"><i class="fas fa-exclamation-circle text-orange-500"></i> Mora actual</div>
        <div class="cd-kpi-value">
          <span [ngClass]="moraBadge(data.mora?.actual || 0)" class="cd-mora-badge">{{ data.mora?.actual || 0 }}d</span>
        </div>
        <div class="cd-kpi-sub">{{ data.mora?.actual_count || 0 }} cuotas · {{ fmtMoney(data.mora?.actual_monto_pendiente) }}</div>
      </div>

      <div class="cd-kpi">
        <div class="cd-kpi-label"><i class="fas fa-coins text-yellow-600"></i> Penalidades</div>
        <div class="cd-kpi-value">{{ data.fees.summary.pendientes_count }} <small>pend</small></div>
        <div class="cd-kpi-sub">{{ fmtMoney(data.fees.summary.pendientes_monto) }} · {{ data.fees.summary.pagados_count }} pagados {{ fmtMoney(data.fees.summary.pagados_monto) }}</div>
      </div>

      <div class="cd-kpi" [ngClass]="scoreBadge()">
        <div class="cd-kpi-label"><i class="fas fa-bullseye text-blue-500"></i> Score</div>
        <div class="cd-kpi-value">{{ data.estadisticas.score }}<small>/10</small></div>
        <div class="cd-kpi-sub">
          {{ data.estadisticas.score_categoria }}
          <span *ngIf="data.estadisticas.tendencia && data.estadisticas.tendencia !== 'sin dato'">
            · <i class="fas" [ngClass]="tendenciaIconClass()"></i>
            {{ data.estadisticas.tendencia }}
          </span>
        </div>
      </div>
    </section>

    <!-- Tabs -->
    <nav class="cd-tabs">
      <button class="cd-tab" [class.active]="activeTab === 'cuotas'" (click)="setTab('cuotas')">Cuotas y mora</button>
      <button class="cd-tab" [class.active]="activeTab === 'recargos'" (click)="setTab('recargos')">Penalidades</button>
      <button class="cd-tab" [class.active]="activeTab === 'estadisticas'" (click)="setTab('estadisticas')">Estadísticas</button>
    </nav>

    <!-- ─── TAB: Cuotas y mora (vista resumida CRÉDITOS + vista detallada CUOTAS) ─── -->
    <section *ngIf="activeTab === 'cuotas'" class="cd-tab-panel">

      <!-- ╔═════ VISTA RESUMIDA: CRÉDITOS (tabla compacta) ═════ -->
      <div class="cd-section-banner">
        <i class="fas fa-clipboard-list text-gray-700"></i>
        <strong>CRÉDITOS</strong> — vista resumida por cuota (tabla compacta)
      </div>

      <div class="cd-card" *ngIf="data.cuotas.en_mora.length > 0">
        <h3><i class="fas fa-exclamation-circle text-red-600"></i> Cuotas en mora ({{ data.cuotas.en_mora.length }})</h3>
        <div class="cd-table-scroll">
          <table class="cd-table cd-table-detalle">
            <thead>
              <tr>
                <th>Cuota</th>
                <th>Crédito</th>
                <th>Vencimiento</th>
                <th>Días atraso</th>
                <th class="cd-th-money">Monto Cuota ($)</th>
                <th class="cd-th-money">Monto Pagado ($)</th>
                <th class="cd-th-money">Monto Adeudado ($)</th>
                <th>Fee Pendiente</th>
                <th class="cd-th-money">Monto fee</th>
                <th>Fecha generación fee</th>
                <th>Broker</th>
                <th>Status fee</th>
                <th>Condición fee</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of data.cuotas.en_mora">
                <td><strong>#{{ c.order }}</strong></td>
                <td>{{ c.invoice_identifier || '#' + c.invoice_number }}</td>
                <td>{{ fmtDate(c.scheduledPaymentDate) }}</td>
                <td><span class="cd-mora-badge" [ngClass]="moraBadge(c.days)">{{ c.days }}d</span></td>
                <td class="cd-money">{{ fmtMoney(c.amount) }}</td>
                <td class="cd-money">{{ fmtMoney(montoPagado(c)) }}</td>
                <td class="cd-money cd-money-pend">{{ fmtMoney(c.dueBalance) }}</td>
                <td>
                  <span *ngIf="c.fee" class="cd-fee-tag">{{ c.fee.concept || '—' }}</span>
                  <span *ngIf="!c.fee" class="cd-muted">—</span>
                </td>
                <td class="cd-money">{{ c.fee ? fmtMoney(c.fee.amount) : '—' }}</td>
                <td>{{ c.fee?.date ? fmtDate(c.fee.date) : '—' }}</td>
                <td>{{ c.fee ? brokerLabel(c.fee.days) : '—' }}</td>
                <td>
                  <span *ngIf="c.fee" class="cd-pill" [ngClass]="feeStatusClass(c.fee)">
                    {{ feeStatusLabel(c.fee) }}
                  </span>
                  <span *ngIf="!c.fee" class="cd-muted">—</span>
                </td>
                <td>{{ c.fee ? feeCondicion(c.fee) : '—' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="cd-card" *ngIf="data.cuotas.proximas.length > 0">
        <h3><i class="fas fa-hourglass-half text-amber-500"></i> Próximas a vencer ({{ data.cuotas.proximas.length }})</h3>
        <table class="cd-table">
          <thead><tr><th>Cuota</th><th>Crédito</th><th>Vence</th><th>Monto</th></tr></thead>
          <tbody>
            <tr *ngFor="let c of data.cuotas.proximas">
              <td>#{{ c.order }}</td>
              <td>#{{ c.invoice_number }}</td>
              <td>{{ fmtDate(c.scheduledPaymentDate) }}</td>
              <td>{{ fmtMoney(c.amount) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="cd-card" *ngIf="data.cuotas.pagadas_recientes.length > 0">
        <h3><i class="fas fa-check-circle text-green-600"></i> Pagadas recientes ({{ data.cuotas.pagadas_recientes.length }})</h3>
        <table class="cd-table">
          <thead><tr><th>Cuota</th><th>Crédito</th><th>Vencía</th><th>Pagó</th><th>Retraso</th><th>Monto</th></tr></thead>
          <tbody>
            <tr *ngFor="let c of data.cuotas.pagadas_recientes">
              <td>#{{ c.order }}</td>
              <td>#{{ c.invoice_number }}</td>
              <td>{{ fmtDate(c.scheduledPaymentDate) }}</td>
              <td>{{ fmtDate(c.payment_date) }}</td>
              <td>
                <span *ngIf="c.debtor_days_count > 0" class="cd-mora-badge" [ngClass]="moraBadge(c.debtor_days_count)">{{ c.debtor_days_count }}d tarde</span>
                <span *ngIf="!c.debtor_days_count" class="cd-pill cd-pill-good">a tiempo</span>
              </td>
              <td>{{ fmtMoney(c.amount) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </section>

    <!-- ─── TAB: Recargos ─── -->
    <section *ngIf="activeTab === 'recargos'" class="cd-tab-panel">
      <!-- Por concepto -->
      <div class="cd-card">
        <h3>Breakdown por concepto</h3>
        <table class="cd-table">
          <thead><tr><th>Concepto</th><th>Pendientes</th><th>$ Pendiente</th><th>Pagados</th><th>$ Pagado</th></tr></thead>
          <tbody>
            <tr *ngFor="let item of porConceptoEntries()">
              <td><span class="cd-fee-tag">{{ item.concepto }}</span></td>
              <td>{{ item.pendientes }}</td>
              <td class="cd-money">{{ fmtMoney(item.pendientes_monto) }}</td>
              <td>{{ item.pagados }}</td>
              <td class="cd-money">{{ fmtMoney(item.pagados_monto) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pendientes -->
      <div class="cd-card" *ngIf="data.fees.pendientes.length > 0">
        <h3>Penalidades pendientes ({{ data.fees.pendientes.length }})</h3>
        <table class="cd-table">
          <thead><tr><th>Concepto</th><th>Días</th><th>Monto</th><th>Pendiente</th><th>Creado</th></tr></thead>
          <tbody>
            <tr *ngFor="let f of data.fees.pendientes">
              <td><span class="cd-fee-tag">{{ f.concept || '—' }}</span></td>
              <td>{{ f.days || '—' }}d</td>
              <td>{{ fmtMoney(f.amount) }}</td>
              <td class="cd-money">{{ fmtMoney(f.due_balance) }}</td>
              <td>{{ fmtDate(f.date) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagados -->
      <div class="cd-card" *ngIf="data.fees.pagados.length > 0">
        <h3>Penalidades pagadas (últimas {{ data.fees.pagados.length }})</h3>
        <table class="cd-table">
          <thead><tr><th>Concepto</th><th>Días</th><th>Monto</th><th>Pagado</th></tr></thead>
          <tbody>
            <tr *ngFor="let f of data.fees.pagados">
              <td><span class="cd-fee-tag">{{ f.concept || '—' }}</span></td>
              <td>{{ f.days || '—' }}d</td>
              <td>{{ fmtMoney(f.amount) }}</td>
              <td>{{ fmtDate(f.last_update_date) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Desactivados -->
      <div class="cd-card" *ngIf="data.fees.desactivados.length > 0">
        <h3>Desactivados ({{ data.fees.desactivados.length }})</h3>
        <table class="cd-table">
          <thead><tr><th>Concepto</th><th>Días</th><th>Monto</th><th>Desactivado</th><th>Motivo</th></tr></thead>
          <tbody>
            <tr *ngFor="let f of data.fees.desactivados">
              <td><span class="cd-fee-tag cd-fee-disabled">{{ f.concept || '—' }}</span></td>
              <td>{{ f.days || '—' }}d</td>
              <td>{{ fmtMoney(f.amount) }}</td>
              <td>{{ fmtDate(f.deleted_at) }}</td>
              <td class="cd-soft">{{ f.message || '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- ─── TAB: Estadísticas ─── -->
    <section *ngIf="activeTab === 'estadisticas'" class="cd-tab-panel">
      <!-- Charts row 1 -->
      <div class="cd-charts-grid">
        <div class="cd-card cd-chart-card">
          <h3>Comportamiento de pago</h3>
          <div class="cd-chart-canvas-sm" *ngIf="(data.cuotas.summary.a_tiempo + data.cuotas.summary.tarde) > 0; else noComport">
            <canvas #comportChart></canvas>
          </div>
          <ng-template #noComport>
            <div class="cd-empty-chart">Sin historial de cuotas pagadas todavía</div>
          </ng-template>
        </div>
        <div class="cd-card cd-chart-card">
          <h3>Tendencia: días promedio de mora</h3>
          <div class="cd-chart-canvas-sm" *ngIf="data.fees.por_mes.length > 0; else noDias">
            <canvas #diasPorMesChart></canvas>
          </div>
          <ng-template #noDias>
            <div class="cd-empty-chart">Sin penalidades registradas — no hay datos de tendencia</div>
          </ng-template>
        </div>
      </div>

      <!-- Chart row 2 (full width) -->
      <div class="cd-card cd-chart-card">
        <h3>Penalidades por mes</h3>
        <div class="cd-chart-canvas" *ngIf="data.fees.por_mes.length > 0; else noFeesMes">
          <canvas #feesPorMesChart></canvas>
        </div>
        <ng-template #noFeesMes>
          <div class="cd-empty-chart">Este cliente nunca ha tenido penalidades</div>
        </ng-template>
      </div>

      <div class="cd-stat-grid">
        <!-- Comportamiento -->
        <div class="cd-card">
          <h3>Comportamiento de pago</h3>
          <table class="cd-stat-table">
            <tr><td>Cuotas a tiempo</td><td class="cd-stat-val">{{ data.cuotas.summary.a_tiempo }} <small>({{ data.cuotas.summary.pct_a_tiempo }}%)</small></td></tr>
            <tr><td>Cuotas tarde</td><td class="cd-stat-val">{{ data.cuotas.summary.tarde }} <small>({{ data.cuotas.summary.pct_tarde }}%)</small></td></tr>
            <tr><td>Días promedio retraso</td><td class="cd-stat-val">{{ data.cuotas.summary.dias_promedio_retraso }}d</td></tr>
            <tr><td>Mora máxima histórica</td><td class="cd-stat-val">{{ data.mora?.max_historica || 0 }}d</td></tr>
            <tr><td>Effective mora (post-react)</td><td class="cd-stat-val">{{ data.mora?.effective ?? '—' }}</td></tr>
          </table>
        </div>

        <!-- Tendencia -->
        <div class="cd-card">
          <h3>Tendencia · Score</h3>
          <table class="cd-stat-table">
            <tr><td>Tendencia</td><td class="cd-stat-val" [ngClass]="tendenciaColor()"><i class="fas" [ngClass]="tendenciaIconClass()"></i> {{ data.estadisticas.tendencia || '—' }}</td></tr>
            <tr><td>Score</td><td class="cd-stat-val">{{ data.estadisticas.score }}/10 — {{ data.estadisticas.score_categoria }}</td></tr>
            <tr><td>Razón del score</td><td class="cd-soft">{{ data.estadisticas.score_razon }}</td></tr>
            <tr *ngIf="data.estadisticas.peor_mes">
              <td>Peor mes</td>
              <td class="cd-stat-val">{{ monthLabel(data.estadisticas.peor_mes.year, data.estadisticas.peor_mes.month) }} — {{ data.estadisticas.peor_mes.dias_promedio }}d</td>
            </tr>
            <tr *ngIf="data.estadisticas.mejor_mes">
              <td>Mejor mes</td>
              <td class="cd-stat-val">{{ monthLabel(data.estadisticas.mejor_mes.year, data.estadisticas.mejor_mes.month) }} — {{ data.estadisticas.mejor_mes.dias_promedio }}d</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- Penalidades por mes -->
      <div class="cd-card" *ngIf="data.fees.por_mes.length > 0">
        <h3>Penalidades por mes ({{ data.fees.por_mes.length }} meses)</h3>
        <table class="cd-table">
          <thead><tr><th>Mes</th><th>Penalidades</th><th>Monto</th><th>Días promedio</th></tr></thead>
          <tbody>
            <tr *ngFor="let m of data.fees.por_mes">
              <td><strong>{{ monthLabel(m.year, m.month) }}</strong></td>
              <td>{{ m.count }}</td>
              <td class="cd-money">{{ fmtMoney(m.monto) }}</td>
              <td>{{ m.dias_promedio }}d</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Créditos -->
      <div class="cd-card" *ngIf="data.creditos.length > 0">
        <h3>Créditos ({{ data.creditos.length }})</h3>
        <table class="cd-table">
          <thead><tr><th>Identificador</th><th>Status</th><th>Tipo</th><th>Plan</th><th>Total</th><th>Fecha</th><th *ngIf="puedeLiq">Liquidación al comercio</th></tr></thead>
          <tbody>
            <tr *ngFor="let c of data.creditos">
              <td>{{ c.identifier || '#' + c.number }}</td>
              <td><span class="cd-pill" [class.cd-pill-good]="c.finished" [class.cd-pill-warn]="!c.finished && c.payment_status === 'Pago Pendiente'">{{ c.payment_status }}</span></td>
              <td>{{ c.type || '—' }}</td>
              <td>{{ c.plan || '—' }}</td>
              <td class="cd-money">{{ fmtMoney(c.total) }}</td>
              <td>{{ fmtDate(c.date) }}</td>
              <td *ngIf="puedeLiq">
                <ng-container *ngIf="marcaDe(c) as m; else sinMarca">
                  <a [routerLink]="['/console/liquidacion/consultas']" [queryParams]="{ vista: 'buscar', venta: c.number }" class="no-underline" [title]="m.texto">
                    <span [ngClass]="claseMarca(m.estado)">{{ m.texto }}</span>
                  </a>
                  <span class="block text-xs text-muted-foreground" *ngIf="m.liquidacion">{{ m.liquidacion }}<span *ngIf="m.pagado_el"> · pagado {{ fechaLiq(m.pagado_el) }}</span><span *ngIf="!m.pagado_el && m.dia_cierre"> · cierre {{ fechaLiq(m.dia_cierre) }}</span></span>
                </ng-container>
                <ng-template #sinMarca><span class="text-xs text-muted-foreground">…</span></ng-template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

  </ng-container>
</div>
